import request from "@/request/request-utils";

export default {
  // 获取线上前端版本
  networkVersion: (url) => request.getAction(url),
};
